import { render, staticRenderFns } from "./ChooseDebtorModal.vue?vue&type=template&id=c58c2058"
import script from "./ChooseDebtorModal.vue?vue&type=script&lang=ts"
export * from "./ChooseDebtorModal.vue?vue&type=script&lang=ts"
import style0 from "./ChooseDebtorModal.vue?vue&type=style&index=0&id=c58c2058&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports